export const BLANK_MONTH = {
  treatmentOutstanding: 0,
  treatmentAccepted: 0,
  revenue: { currency: '', value: 0 },
};
